import { root } from './encoder-channel';

export const encoderChannel = {
  ...root,
};
